export enum JobType{
    CreateTenant = 1,
    IcwAktar = 2,
    IcwAktarDosya = 3,
    IcwAktarFaiz = 4
}